import { Services } from '@sigma-frontend-libs/commons'

import entity from '@/components/entity'
import filterBy from '@/components/services/report-manager/commons/filterBy/entity'
import timeline from '@/components/services/report-manager/commons/timeline'
import dateRange from '@/components/services/report-manager/queue/dateRange/entity'
import file from '@/components/services/report-manager/queue/item/file'
import { serviceNameKebabCase } from '@/components/services/report-manager/queue/utils'

function renderEntity(h) {
  return h(
    entity,
    {
      props: {
        value: this.fields,
        service: Services['report-manager/queue'],
        fields: Object.keys(this.fields)
      }
    }
  )
}

function renderDateRange(h) {
  if (this.value.dateRange) {
    return h(
      dateRange,
      {
        props: {
          value: this.value.dateRange
        }
      }
    )
  }
}

function renderFilterBy(h) {
  return h(
    filterBy,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__header`
    },
    [
      renderEntity.call(this, h),
      renderDateRange.call(this, h),
      renderFilterBy.call(this, h)
    ]
  )
}

function renderTimeline(h) {
  return h(
    timeline,
    {
      props: {
        value: this.value,
        service: Services['report-manager/queue']
      }
    }
  )
}
function renderFile(h) {
  return h(
    file,
    {
      props: {
        value: this.value,
        showInfo: true
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__body`
    },
    [
      renderTimeline.call(this, h),
      renderFile.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
